import { defineNuxtPlugin } from '#imports'
import { h } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('center', {
    name: 'LegacyCenterElement',
    setup(_, { slots, attrs }) {
      const { class: className, style: inlineStyle, ...restAttrs } = attrs
      const normalizedClass = ['legacy-center', className].filter(Boolean)
      const normalizedStyle = {
        textAlign: 'center',
        display: 'block',
        ...(inlineStyle as Record<string, unknown> | undefined)
      }

      return () => h('div', { ...restAttrs, class: normalizedClass, style: normalizedStyle }, slots.default?.())
    }
  })
})
